module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDcgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMSAwLjcyNDYwOUw1LjUgNS4yMjQ2MUwxIDkuNzI0NjEiIHN0cm9rZT0idXJsKCNwYWludDBfbGluZWFyXzI3NV8xOTQpIi8+DQo8ZGVmcz4NCjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yNzVfMTk0IiB4MT0iMy4yNSIgeTE9IjAuNzI0NjA5IiB4Mj0iMy4yNSIgeTI9IjkuNzI0NjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4NCjxzdG9wIHN0b3AtY29sb3I9IiM5MjkyOTIiLz4NCjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzg5ODk4OSIvPg0KPC9saW5lYXJHcmFkaWVudD4NCjwvZGVmcz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/goNext.svg
// module id = bklf
// module chunks = 0